import sidebar from '@/config/sidebars/form_tracking'
import createVueApp from '@/common/create_app'

Styxie.Initializers.FormTrackingSubmits = {
  index: async(props) => {
    const { default: SubmitsIndex } = await import('@/vue_widgets/form_tracking/submits/index.vue')
    createVueApp(SubmitsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: SubmitsShow } = await import('@/vue_widgets/form_tracking/submits/show.vue')
    createVueApp(SubmitsShow, { props, sidebar })
  }
}
